import React from 'react';
import { connect } from 'react-redux';
import Fallback from './FallBack';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    const token = localStorage.getItem('OSS_Token');

    fetch(`${process.env.REACT_APP_TECHNICIANS_API}/Tasks/log-unhandled-error`, {
      ...{
        headers: new Headers({
          'Content-Type': 'application/json',
          accept: 'application/json, application/xml, text/plain, text/html, *.*',
          authorization: `OSS ${token}`,
        }),
      },
      ...{
        method: 'POST',
        mode: 'cors',
        referrerPolicy: 'strict-origin-when-cross-origin',
        body: JSON.stringify({
          error: error.message,
          taskId: this.props.taskId,
          stackTrace: 'minifiedStack',
        }),
      },
    });
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.isAdmin && this.state.hasError) {
      return <Fallback />;
    }

    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}

function mapStateToProps(state) {
  return {
    taskId: state.tasks.taskStarted?.taskId ?? 0,
  };
}

export default connect(mapStateToProps)(ErrorBoundary);
